import { NebiusAcademyLogoOutlined } from 'src/shared/components/nebius-academy-logo/nebius-academy-logo-outlined.js';
import { NebiusAcademyLogo } from 'src/shared/components/nebius-academy-logo/nebius-academy-logo.js';

import { cnHeader } from './header.constants.js';

import './header.css';

export interface HeaderProps {
    logoType?: 'default' | 'outlined';
}

export const Header = ({ logoType = 'default' }: HeaderProps) => (
    <header className={cnHeader()}>
        {logoType === 'default' ? (
            <NebiusAcademyLogo className={cnHeader('logo')} />
        ) : (
            <NebiusAcademyLogoOutlined className={cnHeader('logo')} />
        )}
    </header>
);
